import {
  keepPreviousData,
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

import { questionsApi, type QuestionListParams } from '../api/questions-api';

import { auctionKeys } from './auction-keys';

export function questionListQueryOptions(storeId: string, params: QuestionListParams) {
  return queryOptions({
    queryKey: auctionKeys.questionList(storeId, params),
    queryFn: () => questionsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useQuestions(storeId: string, params: QuestionListParams) {
  return useQuery(questionListQueryOptions(storeId, params));
}

/** An answered or hidden question leaves the pending tab, so every question list refetches. */
export function useAnswerQuestion(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, answer }: { id: string; answer: string }) =>
      questionsApi.answer(storeId, id, answer),
    meta: { successMessage: 'auctions:questions.toasts.answered', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: auctionKeys.questions(storeId) }),
  });
}

export function useHideQuestion(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason: string }) =>
      questionsApi.hide(storeId, id, reason),
    meta: { successMessage: 'auctions:questions.toasts.hidden', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: auctionKeys.questions(storeId) }),
  });
}
